import { useTheme } from "@mui/material";

const ChevronRightFilled = () => {
    const theme = useTheme();
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="ChevronRightFilled">
                <path
                    id="Vector"
                    d="M8.7475 20.3375C8.5575 20.3375 8.3675 20.2675 8.2175 20.1175C7.9275 19.8275 7.9275 19.3475 8.2175 19.0575L14.7375 12.5375C15.2175 12.0575 15.2175 11.2775 14.7375 10.7975L8.2175 4.2775C7.9275 3.9875 7.9275 3.5075 8.2175 3.2175C8.5075 2.9275 8.9875 2.9275 9.2775 3.2175L15.7975 9.7375C16.3075 10.2475 16.5975 10.9375 16.5975 11.6675C16.5975 12.3975 16.3175 13.0875 15.7975 13.5975L9.2775 20.1175C9.1275 20.2575 8.9375 20.3375 8.7475 20.3375Z"
                    fill={theme.palette.common.black}
                    fillOpacity="0.66"
                />
            </g>
        </svg>
    );
};

export default ChevronRightFilled;
